import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`By default, PostHog automatically captures pageviews and pageleaves as well as clicks, change of inputs, and form submissions associated with `}<inlineCode parentName="p">{`a`}</inlineCode>{`, `}<inlineCode parentName="p">{`button`}</inlineCode>{`, `}<inlineCode parentName="p">{`form`}</inlineCode>{`, `}<inlineCode parentName="p">{`input`}</inlineCode>{`, `}<inlineCode parentName="p">{`select`}</inlineCode>{`, `}<inlineCode parentName="p">{`textarea`}</inlineCode>{`, and `}<inlineCode parentName="p">{`label`}</inlineCode>{` tags. See our `}<a parentName="p" {...{
        "href": "/docs/product-analytics/autocapture"
      }}>{`autocapture docs`}</a>{` for more details on this.`}</p>
    <p>{`If you prefer to disable or filter these, set the appropriate values in your `}<a parentName="p" {...{
        "href": "/docs/libraries/js/config"
      }}>{`configuration options`}</a>{`.`}</p>
    <h2 {...{
      "id": "capturing-custom-events"
    }}>{`Capturing custom events`}</h2>
    <p>{`After setting up the PostHog provider, you can use the `}<inlineCode parentName="p">{`usePostHog`}</inlineCode>{` hook to access all the methods of the `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` library including `}<inlineCode parentName="p">{`capture`}</inlineCode>{` which lets you capture custom events with optional properties.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { usePostHog } from '@posthog/react'

function App() {
  const posthog = usePostHog()

  const signUpClicked = () => {
    posthog?.capture('clicked_sign_up', {
      signup_method: 'email'
    })
  }

  return (
    <div className="App">
      <button onClick={() => posthog?.capture('button_clicked')}>Click me</button>
      <button onClick={signUpClicked}>Sign up</button>
    </div>
  )
}

export default App
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      